import type { PropsWithChildren } from 'react';
import { useState } from 'react';
import type { WidgetPage, WidgetPageType } from '../../types';
import { DEFAULT_PAGE } from '../constants';
import {
  NavigationContext,
  type NavigationContextType,
  useNavigation
} from '../hooks/use-navigation';
import { pages } from '../pages';

export function NavigationSwitcher({
  onCloseRequest
}: {
  onCloseRequest: WidgetPage['onCloseRequest'];
}) {
  const { currentPage } = useNavigation();

  const Current = pages[currentPage] || pages.main;

  return <Current onCloseRequest={onCloseRequest} />;
}

export function NavigationProvider({ children }: PropsWithChildren) {
  const [currentPage, setCurrentPage] = useState<WidgetPageType>(DEFAULT_PAGE);

  const go: NavigationContextType['go'] = (to) => setCurrentPage(to);
  const backToMainPage = () => setCurrentPage('main');

  return (
    <NavigationContext.Provider value={{ currentPage, go, backToMainPage }}>
      {children}
    </NavigationContext.Provider>
  );
}
